<template>
  <div>
    <my-head></my-head>
    <img src="../assets/Rectangle353.png" style="width:100%">
    <div class="partners minH">
      <div class="flex-between" style="margin-top: 40px;">
        <div class="crumbs">
          首页 > 
          <span style="color: #1d2129">关于我们</span>
        </div>
        <div class="crumbs_input flex-between">
          <input type="text" />
          <img src="../assets/search.png" alt="搜索" />
        </div>
      </div>
      <el-divider></el-divider>
      <div class="da_biao_ti">Partners</div>
      <div class="biao_ti">
        <div>合作机构</div>
        <div class="xia"></div>
      </div>
      <div class="list flex-between flex-wrap">
        <cooperation-card
          class="col"
          v-for="(item, index) in 9"
          :key="index"
        ></cooperation-card>
      </div>
      <div class="flex-center fen_ye">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="100"
          layout="prev, pager, next, jumper"
          :total="1000"
        >
        </el-pagination>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import CooperationCard from "../components/CooperationCard.vue";
export default {
  name: "partners",
  components: { MyHead, MyFooter, CooperationCard },
  data() {
    return {
      currentPage3: 1,
      cardsleft: 0,
    };
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss">
.partners {
  width: 80%;
  margin: 0 auto;

  .fen_ye {
    margin-top: 48px;
    margin-bottom: 88px;
  }
  .list {
    .col {
      width: 48%;
      margin-bottom: 24px;
    }
  }
  .biao_ti {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    display: inline-block;
    margin-bottom: 32px;
    .xia {
      content: "";
      display: block;
      width: 100%;
      height: 4px;
      background: #e5e6eb;
      margin-top: 8px;
      &::before {
        content: "";
        display: block;
        width: 50%;
        height: 4px;
        background: #0e42d2;
      }
    }
  }
  .da_biao_ti {
    font-size: 38px;
    font-weight: 800;
    color: #c9cdd4;
    line-height: 45px;
    margin-bottom: 24px;
  }
  .crumbs {
    font-size: 12px;
    color: #86909c;
  }
  .crumbs_input {
    width: 261px;
    height: 36px;
    background: #f7f8fa;
    border-radius: 4px 4px 4px 4px;
    padding: 0 15px;
    input {
      height: 22px;
      flex: 1;
      border: none;
      outline: none;
      background: #f7f8fa;
    }
    img {
      cursor: pointer;
      width: 14px;
      margin-left: 14px;
    }
  }
}
</style>
